import { useId } from 'react';
import { LOCALE, t } from '../../i18n';

/**
 * Settings, on the Profile tab (A6; D26): the rows to come, shown now and off. The language is
 * English until Phase H brings Turkish and turns this choice on; the notifications come with Phase
 * E's push, whose own rows (E4) replace this one. Both hold their value (no onChange), so even a
 * tap a browser lets through leaves them as they are.
 */
export function Settings() {
  const headingId = useId();
  const languageId = useId();
  const languageNoteId = useId();
  const notificationsNoteId = useId();
  return (
    <section className="settings" aria-labelledby={headingId}>
      <h2 id={headingId}>{t('settings.title')}</h2>
      <div className="field">
        <label htmlFor={languageId}>{t('settings.language')}</label>
        <select
          id={languageId}
          name="language"
          value={LOCALE}
          disabled
          aria-describedby={languageNoteId}
        >
          <option value="en">{t('settings.english')}</option>
        </select>
        <p id={languageNoteId} className="field-hint">
          {t('settings.languageNote')}
        </p>
      </div>
      <div>
        <label className="choice-option">
          <input
            type="checkbox"
            name="notifications"
            checked={false}
            disabled
            aria-describedby={notificationsNoteId}
          />
          {t('settings.notifications')}
        </label>
        <p id={notificationsNoteId} className="field-hint">
          {t('settings.notificationsNote')}
        </p>
      </div>
    </section>
  );
}
